import Udesk from 'Udesk';
import Tempalte from '../Template/index.tsx';
import React from 'react';

class Component extends React.Component {
    render() {
        return (
            <Tempalte
                {...this.props}
                inspectDataSource={Udesk.enums.inspectDataSources.eComment.id}
            />
        );
    }
}

export default Udesk.react.udeskify(Component);
